import { faSync } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function resetBusCounterError() {
    return (
        <div data-cy="historic-reboot">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.resetBusCounterError" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faSync} style={{ color: '#ffca28' }} size="lg" />
            </Whisper>
        </div>
    );
}
